import {WebThemeManager} from "@project/design-system-web";
import {env} from "@project/env";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "../../app";

// Initialise theme before React mounts.
// localStorage is synchronous — the resolved theme is applied to <html> instantly,
// so there is no flash of unstyled content (FOUC).
// The manager also attaches a matchMedia listener for OS scheme changes.
WebThemeManager.getInstance().init();

async function bootstrap() {
  // Start the MSW browser worker in mock mode only.
  // env.VITE_MOCK is already a boolean (transformed by env.ts).
  if (env.VITE_MOCK) {
    const {worker} = await import("../mocks/worker");

    await worker.start({onUnhandledRequest: "bypass"});
  }

  if (import.meta.env.DEV) {
    const axe = await import("@axe-core/react");

    axe.default(React, ReactDOM, 1000);
  }

  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

void bootstrap();
